// extracted by mini-css-extract-plugin
export default {"bottom":"flight-request-edit_bottom__qWu0j"};